import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { Coupon } from '../../../../types';
import { updateExpirationDatePaymentCoupon } from '../../../../../../../../crud/payments_api/payment_coupons';
import { toast } from 'react-toastify';
import { X } from 'react-bootstrap-icons';

interface UpdateDateCouponProps {
  show: boolean;
  handleClose: () => void;
  coupons: Coupon[];
  setCoupon: (coupons: Coupon[]) => void;
  coupon: Coupon;
}

const UpdateCouponDate: React.FC<UpdateDateCouponProps> = ({
  show,
  handleClose,
  coupons,
  setCoupon,
  coupon,
}) => {
  // Inicializamos selectedExpirationDate a partir de coupon.expiration_date (convertido a Date si existe)
  const [selectedExpirationDate, setSelectedExpirationDate] = useState<Date | null>(
    coupon.expiration_date ? new Date(coupon.expiration_date) : null
  );

  // Estado para controlar si se muestra el calendario
  const [showCalendar, setShowCalendar] = useState(true);

  useEffect(() => {
    setSelectedExpirationDate(coupon.expiration_date ? new Date(coupon.expiration_date) : null);
  }, [coupon]);

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header>
      <div className="form-modal-title-container">
        <Modal.Title className="form-modal-title">Actualizar Fecha</Modal.Title>
        </div>
                <Button variant="none" className="modal-close-button" onClick={handleClose}>
                  <X size={24} />
                </Button>
      </Modal.Header>
      <Modal.Body>
        {showCalendar && (
          <div className='mp-form-calendar-container'>
          <Calendar
            onChange={(date) => {
              const newDate = date as Date;
              setSelectedExpirationDate(newDate);
              setShowCalendar(false);
              // Preparamos el payload con la fecha formateada a "YYYY-MM-DD"
              const payload = { expiration_date: newDate.toISOString().split('T')[0] };
              updateExpirationDatePaymentCoupon(coupon.payment_coupon_id, payload)
                .then((response) => {
                  // Actualizamos el cupón con la nueva fecha (se asigna como objeto Date)
                  const updatedCoupon: Coupon = { ...coupon, expiration_date: newDate };
                  const updatedCoupons = coupons.map((cp) =>
                    cp.payment_coupon_id === coupon.payment_coupon_id ? updatedCoupon : cp
                  );
                  setCoupon(updatedCoupons);
                  toast.success('Fecha actualizada exitosamente');
                  // Cierra el modal tras actualizar
                  handleClose();
                })
                .catch((error) => {
                  console.error('Error al actualizar la fecha: ', error);
                  toast.error('Error al actualizar la fecha');
                  handleClose();
                });
            }}
            value={selectedExpirationDate}
            locale="es-ES"
            className="mp-form-calendar"
            selectRange={false}
          />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateCouponDate;
